import { clone } from '@/utils/handleData'
var Base64 = require('js-base64').Base64
const mutations = {
  // 基础更新state方法
  baseSet(state, params = {}) {
    var stateValue
    if (params.module && (params.value || params.value === 0)) {
      state[params.module][params.key] = params.value
    } else if (params.module && params.fields) {
      stateValue = JSON.parse(JSON.stringify(state[params.module][params.key]))
      for (var field in params.fields) {
        stateValue[field] = params.fields[field]
      }
      state[params.module][params.key] = stateValue
    } else {
      state[params.key] = params.value
    }
  },
  // 统一字典表更新方法
  dictionarySet(state, params = {}) {
    var dictionarys = JSON.parse(JSON.stringify(state.dictionarys))
    dictionarys[params.key] = params.value
    state.dictionarys = dictionarys
  },
  // 统一机构下字典表更新方法
  orgFieldsSet(state, params = {}) {
    var orgFields = JSON.parse(JSON.stringify(state.orgFields))
    orgFields[params.key] = params.value
    state.orgFields = orgFields
  },
  // 统一地图参数更新方法
  mapOptionsSet(state, params = {}) {
    var mapOptions = JSON.parse(JSON.stringify(state.mapOptions))
    mapOptions[params.key] = params.value
    state.mapOptions = mapOptions
  },
  // 更新操作步骤
  stepSet(state, params = {}) {
    var historyStep = JSON.parse(JSON.stringify(state.historyStep))
    const stepName = (step) => (step && step.step ? String(step.step) : '')
    const isListStep = (step) => stepName(step).slice(-4) === 'List'
    if (params.type === 'toggle') {
      // 当前步骤同级切换：清空分步进度
      state.activeStep = 0
      state.currentStep = params.toggle
    } else if (params.type === 'forward') {
      // 从列表进入新表单时重置分步；从表单进子页（添加企业/人员）时保留分步，返回可还原
      if (isListStep(state.currentStep)) {
        state.activeStep = 0
      }
      historyStep.push(state.currentStep)
      state.currentStep = params.forward
    } else if (params.type === 'back') {
      // 返回上一级：保留 activeStep，供 stepForm 还原跳转前分步
      state.currentStep = historyStep.length
        ? historyStep.pop()
        : state.currentStep
      if (isListStep(state.currentStep)) {
        state.activeStep = 0
      }
    } else if (params.type === 'toAny') {
      // 返回任一步骤
      state.currentStep = params.toAny
      for (var i = 0; i < historyStep.length; i++) {
        if (params.toAny.step === historyStep[i].step) {
          const num = historyStep.length - i
          historyStep.splice(i, num)
          break
        }
      }
      if (isListStep(params.toAny)) {
        state.activeStep = 0
      }
    }
    state.historyStep = historyStep
  },
  // 更新缓存图片
  pictureSet(state, params = {}) {
    // params.value为图片uid组成的数组
    var fileList = []
    if (params.value) {
      params.value.forEach((uid) => {
        var url = ''
        if (uid && !params.type) {
          url =
            state.baseURL +
            state.uploadImage +
            '/' +
            uid +
            '/420_0_100?token=' +
            Base64.encode(window.sessionStorage.getItem('token'))
        } else if (uid && params.type === 'signature') {
          url =
            state.baseURL +
            state.uploadSignature +
            '/' +
            uid +
            '/80_30?token=' +
            Base64.encode(window.sessionStorage.getItem('token'))
        } else if (uid && params.type === 'face') {
          url =
            state.baseURL +
            state.uploadFaceimage +
            '/' +
            uid +
            '/180_240_100?token=' +
            Base64.encode(window.sessionStorage.getItem('token'))
        }
        if (uid) {
          fileList.push({ url: url, uid: uid, name: params.name })
        }
      })
    }
    var pictures = JSON.parse(JSON.stringify(state.pictures))
    pictures[params.key] = fileList
    state.pictures = pictures
  },
  // 更新缓存报表
  reportSet(state, params = {}) {
    var url = ''
    if (!params.type) {
      url =
        state.baseURL +
        state.uploadImage +
        '/' +
        params.picUid +
        '/800_0_100?token=' +
        Base64.encode(window.sessionStorage.getItem('token'))
    } else if (params.type === 'contractReport') {
      url =
        state.baseURL +
        state.reportImg +
        '?contractUid=' +
        params.contractUid +
        '&reportUid=' +
        params.reportUid +
        '&token=' +
        Base64.encode(window.sessionStorage.getItem('token'))
    } else if (params.type === 'defaultreport') {
      url =
        state.baseURL +
        state.defaultreport +
        '?reportUid=' +
        params.reportUid +
        '&orgUid=' +
        params.orgUid +
        '&token=' +
        Base64.encode(window.sessionStorage.getItem('token'))
    }
    var reports = JSON.parse(JSON.stringify(state.reports))
    reports[params.key] = url
    state.reports = reports
  },
  // 更新缓存文件
  fileSet(state, params = {}) {
    var url =
      state.baseURL +
      state.uploadfile +
      '/' +
      params.uid +
      '?token=' +
      Base64.encode(window.sessionStorage.getItem('token'))
    var files = JSON.parse(JSON.stringify(state.files))
    files[params.key] = {
      uid: params.uid,
      url: url,
      name: params.name,
      type: params.type
    }
    state.files = files
  },
  // 更新表单数据uid
  parentUidsSet(state, params = {}) {
    var parentUids = JSON.parse(JSON.stringify(state.parentUids))
    parentUids[params.key] = params.value
    state.parentUids = parentUids
  },
  // 更新表单数据uid
  currentUidsSet(state, params = {}) {
    var currentUids = JSON.parse(JSON.stringify(state.currentUids))
    currentUids[params.key] = params.value
    state.currentUids = currentUids
  },
  // 更新表单状态
  pageStatusSet(state, params = {}) {
    var pageStatus = JSON.parse(JSON.stringify(state.pageStatus))
    pageStatus[params.key] = params.value
    state.pageStatus = pageStatus
  },
  // 更新表单错误提示
  formErrorSet(state, params = {}) {
    var formError = JSON.parse(JSON.stringify(state.formError))
    formError[params.key] = params.value
    state.formError = formError
  },
  // 更新表单校验规则
  validateSet(state, params = {}) {
    var validate = clone(state.validate)
    validate[params.key] = params.value
    state.validate = validate
  },
  // 更新表头查询参数值
  queryValuesSet(state, params = {}) {
    var queryValues = JSON.parse(JSON.stringify(state.queryValues))
    queryValues[params.key] = params.value
    state.queryValues = queryValues
  },
  // 更新列表页码
  pageSet(state, params = {}) {
    var page = JSON.parse(JSON.stringify(state.page))
    page[params.key] = params.value
    state.page = page
  },
  // 更新列表条数
  limitSet(state, params = {}) {
    var limit = JSON.parse(JSON.stringify(state.limit))
    limit[params.key] = params.value
    state.limit = limit
  },
  // 更新列表当前选中行
  currentRowSet(state, params = {}) {
    var currentRow = JSON.parse(JSON.stringify(state.currentRow))
    currentRow[params.key] = params.value
    state.currentRow = currentRow
  },
  // 更新列表选择项
  // 只浅拷贝「当前页 key」的行，避免：
  // 1) 整表 JSON 深拷贝导致勾选卡顿
  // 2) 与表格 row 共用引用时，业务里改 selection 会污染列表数据
  selectionSet(state, params = {}) {
    var value = params.value
    if (Array.isArray(value)) {
      value = value.map(function (row) {
        return row && typeof row === 'object' ? Object.assign({}, row) : row
      })
    }
    state.selection = Object.assign({}, state.selection, {
      [params.key]: value
    })
  },
  // 更新列表当前展开行
  expandRowKeysSet(state, params = {}) {
    var expandRowKeys = JSON.parse(JSON.stringify(state.expandRowKeys))
    expandRowKeys[params.key] = params.value
    state.expandRowKeys = expandRowKeys
  },
  // 更新表格最大高度
  maxHeightSet(state, params = {}) {
    var maxHeight = JSON.parse(JSON.stringify(state.maxHeight))
    maxHeight[params.key] = params.value
    state.maxHeight = maxHeight
  },
  // 更新表单参数值
  formValuesSet(state, params = {}) {
    if (!params.key) return
    var formValues = JSON.parse(JSON.stringify(state.formValues))
    if (!params.fields && params.value) {
      formValues[params.key] = params.value
    } else if (Object.keys(params.fields).length) {
      for (var field in params.fields) {
        if (!formValues[params.key]) {
          formValues[params.key] = {}
        }
        formValues[params.key][field] = params.fields[field]
      }
    }
    state.formValues = formValues
  },
  setFileUploading(state, params = {}) {
    if (!params.id) return
    const next = Object.assign({}, state.fileUploadingMap || {})
    if (params.value) {
      next[params.id] = true
    } else {
      delete next[params.id]
    }
    state.fileUploadingMap = next
  },
  clearFileUploading(state) {
    state.fileUploadingMap = {}
  },
  unsavedUploadSessionSet(state, value = {}) {
    state.unsavedUploadSession = {
      images: Array.isArray(value.images) ? value.images : [],
      qiniu: Array.isArray(value.qiniu) ? value.qiniu : [],
      committed: value.committed !== false
    }
  }
}

export default mutations
